import usePersonalizedThemeByCompany from "src/hooks/usePersonalizedThemeByCompany"

export default function ClockIconCalendar() {
  const { styledTheme } = usePersonalizedThemeByCompany()

  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 3.66667V7H5M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z" stroke={styledTheme.icons.colors.darkContour} stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )
}